export default {
  cpp: [
    {
      title: "Mkanta",
      lang: "C++20",
      caption: "Reflection Library",
      detail: "https://github.com/tyanmahou/Mkanta",
    },
    {
      title: "Emaject",
      lang: "C++20",
      caption: "Dependency Injection Library",
      detail: "https://github.com/tyanmahou/Emaject",
    },
    {
      title: "Magico",
      lang: "C++17",
      caption: "Concept Library",
      detail: "https://github.com/tyanmahou/Magico",
    },
    {
      title: "ColorCpp",
      lang: "C++20",
      caption: "C++20 ColorSpace Module",
      detail: "https://github.com/tyanmahou/ColorCpp",
    },
    {
      title: "S3DTiled",
      lang: "C++/OpenSiv3D",
      caption: "Tiled Support",
      detail: "https://github.com/tyanmahou/S3DTiled",
    },
    {
      title: "SQLite-for-Siv3D",
      lang: "C++/OpenSiv3D",
      caption: "SQLite Support",
      detail: "https://github.com/tyanmahou/SQLite-for-Siv3D",
    },
  ],
  unity: [
    {
      title: "Unity-MahouLab",
      lang: "C#/Unity",
      caption: "Utility",
      detail: "https://github.com/tyanmahou/Unity-MahouLab",
    },
    {
      title: "MysticLauncher",
      lang: "C#/Unity",
      caption: "Unity Launcher Tool",
      detail: "https://github.com/tyanmahou/Unity-MysticLauncher",
    },        
  ]
};